const API_URL = process.env.REACT_APP_API_URL;

export const checkEdrpouCode = async (edrpou) => {
  try {
    const response = await fetch(`${API_URL}/api/public-requests/check-edrpou`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ edrpou }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const submitPublicRequest = async (formData) => {
  try {
    const isJson = typeof formData === 'string';
    const response = await fetch(`${API_URL}/api/public-requests/submit`, {
      method: 'POST',
      headers: isJson ? { 'Content-Type': 'application/json' } : undefined,
      body: formData,
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    throw error;
  }
};

/**
 * Отримує довідники (зони завантаження, коди операторів тощо)
 */
export const getPublicReferences = async () => {
  try {
    const response = await fetch(`${API_URL}/api/requests/references`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to load references:', error);
    return {};
  }
};

/**
 * Залишено для зворотної сумісності
 */
export const getLoadingZones = async () => {
  const data = await getPublicReferences();
  const ignoreNames = ['personal computer sample'];
  return (data?.SuLoadingZone || [])
    .filter((z) => !ignoreNames.includes((z.Name || '').toLowerCase()))
    .sort((a, b) => {
      const orderA = a.sortOrder && Number(a.sortOrder) > 0 ? Number(a.sortOrder) : null;
      const orderB = b.sortOrder && Number(b.sortOrder) > 0 ? Number(b.sortOrder) : null;

      if (orderA !== null && orderB !== null) return orderA - orderB;
      if (orderA !== null) return -1;
      if (orderB !== null) return 1;

      const numA = parseInt(a.SerialNumber, 10) || 0;
      const numB = parseInt(b.SerialNumber, 10) || 0;
      if (numA !== numB) return numA - numB;
      return (a.Name || '').localeCompare(b.Name || '');
    });
};
